import { NETWORK_ERROR, isApiError } from "@/shared/api/errors";
import type { MessageId } from "@/shared/i18n/messages";

/* What attendance's stable error codes mean to the person who hit them. */
const MESSAGES: Readonly<Partial<Record<string, MessageId>>> = {
  PERIOD_LOCKED: "attendance.errors.periodLocked",
  PERIOD_FINAL: "attendance.errors.periodFinal",
  PERIOD_HAS_BLOCKERS: "attendance.errors.periodBlockers",
  ALREADY_CLOCKED_IN: "attendance.errors.alreadyClockedIn",
  NOT_CLOCKED_IN: "attendance.errors.notClockedIn",
  WORK_SESSION_NOT_FOUND: "attendance.errors.sessionNotFound",
  WORK_SESSION_OVERLAP: "attendance.errors.sessionOverlap",
  WORK_SESSION_INVALID: "attendance.errors.sessionInvalid",
  ATTENDANCE_EMPLOYEE_NOT_FOUND: "attendance.errors.noRecord",
  REASON_REQUIRED: "attendance.errors.reason",
  ATTENDANCE_POLICY_INVALID: "attendance.errors.policyInvalid",
  ATTENDANCE_IMPORT_NOT_FOUND: "attendance.errors.importNotFound",
  ATTENDANCE_IMPORT_COMMITTED: "attendance.errors.importCommitted",
  ATTENDANCE_IMPORT_UNREADABLE: "attendance.errors.importUnreadable",
  ATTENDANCE_REQUEST_NOT_FOUND: "attendance.errors.requestNotFound",
  ATTENDANCE_REQUEST_EXISTS: "attendance.errors.requestExists",
  REQUEST_CLOSED: "attendance.errors.requestClosed",
  PERMISSION_TOO_LONG: "attendance.errors.permissionTooLong",
  PERMISSION_OVER_QUOTA: "attendance.errors.permissionOverQuota",
  BREAK_ALREADY_STARTED: "attendance.errors.breakAlreadyStarted",
  BREAK_NOT_STARTED: "attendance.errors.breakNotStarted",
  BREAK_INVALID: "attendance.errors.breakInvalid",
  BREAK_NOT_FOUND: "attendance.errors.breakNotFound",
  WEEKLY_REST_REQUIRED: "attendance.errors.weeklyRestRequired",
  VALIDATION_FAILED: "attendance.errors.validation",
  VERSION_CONFLICT: "errors.conflict",
  PERMISSION_DENIED: "errors.forbidden",
  [NETWORK_ERROR]: "errors.network",
};

/** A sentence for any failed attendance call; the generic one for codes it does not know. */
export function attendanceErrorMessage(error: unknown): MessageId {
  return (isApiError(error) ? MESSAGES[error.code] : undefined) ?? "errors.generic";
}

/** Whether the person has no HR record (or attendance is not tracked for them). */
export function isUntracked(error: unknown): boolean {
  return isApiError(error, "ATTENDANCE_EMPLOYEE_NOT_FOUND", "EMPLOYEE_NOT_FOUND");
}
